import React from 'react'
import styles from './AnalyticsPdfOverview.module.css'

const AnalyticsPdfChartBar = ({ page, percentage, avgTime }) => (
  <div className={styles.chartBar}>
    <div className={styles.barWrapper}>
      <div className={styles.bar} style={{ height: `${percentage}%` }} data-tooltip={`${avgTime}s`} />
    </div>
    <div className={styles.barLabel}>Page {page}</div>
  </div>
)

export default AnalyticsPdfChartBar
